import { Icon } from "@opendash/icons";
import React from "react";
import { Description } from "./Description";
const InactiveOverlay = ({ message, active, height, width, style, icon, children, }) => {
    return (React.createElement(React.Fragment, null, active && (React.createElement("div", { style: {
            zIndex: 1,
            margin: "auto",
            ...style,
            width: width,
            height: height,
            backdropFilter: "blur(10px)",
            position: "absolute",
            textAlign: "center",
        } },
        icon && (React.createElement(Icon, { icon: icon, size: "4em", color: "grey", style: { marginTop: height / 2 - 20 } })),
        message && React.createElement(Description, null, message),
        children))));
};
export { InactiveOverlay };
//# sourceMappingURL=InactiveOverlay.js.map